import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Hamburger from 'hamburger-react'
import {faCartShopping} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { store } from "./redux/store";




export default function Navbar_top(props) {

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: -3,
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }));

  const [doo,setDoo]=useState(false)
  const navigate=useNavigate()
  const NManim=(arr)=>{
    const work=(str)=>{
      setTimeout(() => {
        for(let i=0;i<27;i++){
          document.getElementsByClassName('lm-items')[i].classList.add(str);
        }
      }, 100);
    }
    setTimeout(() => {
      document.getElementById("Lmenu1id").classList.add('Lmenu1-close');
      document.getElementById("lm-headid").classList.add('lmhead-close');
      document.getElementById('Lmenu2id').style.animation='close 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    }, 100);
    work('lm-items_move');
    setTimeout(() => {
      work('lm-items_top');
      setTimeout(() => {
        for(let i=0;i<27;i++){
          document.getElementsByClassName('lm-items')[i].classList.remove('lm-items_move');
        }
      }, 100);
      for(let j=0;j<27;j++){
        document.getElementsByClassName('lm-items')[j].style.display='none'
      }
      for(let j=0;j<27;j++){
        arr.forEach(element => {
          if(element==j){
            document.getElementsByClassName('lm-items')[j].style.display='block'
          }
        });
      }
    }, 1200);
    setTimeout(() => {
      work('lm-items_move');
      setTimeout(() => {
        for(let i=0;i<27;i++){
          document.getElementsByClassName('lm-items')[i].classList='lm-items'
          document.getElementsByClassName('txt-itm')[i].classList.remove("txtitm-chg");
        }
      }, 1400);
    }, 1300);
   
  }
  setTimeout(() => {
    if(props.flg){
      for(let j=6;j<27;j++){
        document.getElementsByClassName('lm-items')[j].style.display='none'
      }
      props.setflg(false);
    }
  }, 0);
 const clean3=()=>{
  let temp=document.getElementsByClassName('topnvelems');
  for(let i=0;i<6;i++){
    temp[i].classList.remove('topnvelemsAfter');
    temp[i].style.color='white';
  }
 
 }
 const put=(strn)=>{
  let temp=document.getElementById(strn)
  temp.classList.add('topnvelemsAfter');
  temp.style.color='#ff5112';
 }
 const hideSetting=()=>{  
  document.getElementById('rmitems4').style.display='none'
 }
  const lm_act_primary=()=>{
    NManim([0,1,2,3,4,5]);
    clean3();
    put("topnvelem-id1");
    props.order(true) 
    hideSetting()   
  }
  const lm_act_appearance=()=>{
    NManim([18,20,2,22,6,8,15,17]);
    clean3();
    put("topnvelem-id2");
    props.order(true)
    hideSetting()
  }
  const lm_act_exit=()=>{
    NManim([19,21,3,23,24,25,15,26]);
    clean3();
    put("topnvelem-id3");
    props.order(true)
    hideSetting()
  }
  const lm_act_text=()=>{
    NManim([9,10,7,8,14]);
    clean3();
    put("topnvelem-id4");
    props.order(false)
    hideSetting()
  }
  const lm_act_focus=()=>{
    NManim([16]);
    clean3();
    put("topnvelem-id5");
    props.order(true)
    hideSetting()
  }
  const lm_act_background=()=>{
    NManim([11,12,13]);
    clean3();
    put("topnvelem-id6");
    props.rte("Background")
    hideSetting()
    navigate("/Background")
    props.order(true)
  }

  const open=()=>{
      document.getElementById('downloadid').style.display='block';
      setTimeout(() => {
        document.getElementById('downloadid').classList='download';
        document.getElementById('downloadid').classList.add('downloadexpand');
      }, 200);
      setTimeout(() => {
        document.getElementById('storage').classList='downloadBox';
       document.getElementById('storage').classList.add('downloadBoxAppear');
  
    }, 1000);
    setTimeout(() => {
        document.getElementById('selCode').classList='codeBox';
        document.getElementById('selCode').classList.add('codeBoxappear');
    }, 1100);
    setTimeout(() => {
        document.getElementById('kfrCode').classList='codeBox';
        document.getElementById('kfrCode').classList.add('codeBoxappear');
    },1200);
  }
  const close=()=>{
    document.getElementById('downloadid').classList.add('downloadshrink');
    setTimeout(() => {
      document.getElementById('downloadid').style.display='none';
    }, 300);
    
  }

    useEffect(()=>{
        if(doo){
          open()
        }else{
          close()
        }
    },[doo])
  return (
    <>
     <div className="topnav flex">
      <div className="topnvelems topnvelemsAfter topnvelmsSelected " id="topnvelem-id1" onClick={lm_act_primary}>Primary</div>
      <div className="topnvelems" id="topnvelem-id2" onClick={lm_act_appearance}>Appearance</div>
      <div className="topnvelems" id="topnvelem-id3" onClick={lm_act_exit}>Exit</div>
      <div className="topnvelems" id="topnvelem-id4" onClick={lm_act_text}>Text</div>
      <div className="topnvelems" id="topnvelem-id5" onClick={lm_act_focus}>Focus</div>
      <div className="topnvelems" id="topnvelem-id6" onClick={lm_act_background} style={{display:"none"}}>Background</div>
      <div className="hamicon"><Hamburger color="white" size={20} onToggle={toggled => {
  if (toggled) {
    setTimeout(() => {
      document.getElementById('hamburgerid').style.right='0px'
    }, 50);
      document.getElementById('hamext').style.display='block'
      document.getElementById('hamburgerid').style.display='block'
  } else {
    setTimeout(() => {
      document.getElementById('hamburgerid').style.display='none'
    }, 500);
    document.getElementById('hamburgerid').style.right='-400px'
      document.getElementById('hamext').style.display='none'
  }}} /></div>
    </div>
   
    <div style={{position:"absolute",right:"50px",cursor:"pointer"}}>
    <IconButton aria-label="cart">
      <StyledBadge badgeContent={store.getState().red1.favdata.length} color="info" onClick={()=>setDoo(!doo) } max={9}>
        <ShoppingCartIcon style={{color:"white",fontSize:22}}  />
      </StyledBadge>
    </IconButton>
    </div>
    </>
   
  );
}
